module.exports = __webpack_public_path__ + "media/images/icon__twitter@3x-3374424d51e7e727decc5518321025ed.png";